import { forwardRef } from 'react';

import { Input, type InputProps } from './Input';
import styles from './SearchInput.module.css';

export type SearchInputProps = Omit<InputProps, 'type'>;

/** A search box: the field with a magnifier inside it, for toolbars above a list. */
export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { className, ...rest },
  ref,
) {
  return (
    <span className={[styles.box, className].filter(Boolean).join(' ')}>
      <svg
        className={styles.icon}
        viewBox="0 0 24 24"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      >
        <path d="M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-3.5-3.5" />
      </svg>
      <Input ref={ref} type="search" autoComplete="off" className={styles.input} {...rest} />
    </span>
  );
});
